<nz-skeleton
  class="p-4"
  [nzActive]="true"
  [nzParagraph]="{ rows: 9 }"
></nz-skeleton>
